export default {
  components:{
    search:{
      placeholder: "Search",
      enterButton: "Find"
    },
    adms:{
      repository_tooltip  : `Loaded {{count}} record. There are also {{length}} records available.`,
      repository_load_next: "Load next",
      distribution: {
        title: "Distribution",
        nolinks: "The catalog item is not distributed.",
        nofiles: "There is no file to download for the content",
        show: {
          title: "Distribution details",
          cancelText: "Cancel",
          okText: "Ok",
          },
        add: {
          title: "Selecting a file to link",
          cancelText: "Cancel",
          okText: "Link",
          },
        unlink:{
          title: 'Delete selected item',
          okText: 'Yes', 
          cancelText: 'No',
        },
        message: {
          ok_link: "The file has been added.",
          ok_unlink: "The entry has been deleted.",
          e_detail: "An error occurred while retrieving more information and distributing a catalog item. {{detail}}",
          e_search: "An error occurred while searching for files. {{detail}}",
        },
      },
    },
    widgets: {
      description_moreText: "Expand",
      description_lessText: "Collapse",
    },
    wiki: {
      title: "Wiki page",
      nolinks: "No related wiki pages",
      select: {
        title: "Selecting a wiki page",
        cancelText: "Cancel",
        okText: "Link",
      },
      unlink_dialog:{
        title: 'Delete selected item',
        okText: 'Yes', 
        cancelText: 'No',
      },
      message: {
        ok_link: "The page has been added.",
        ok_unlink: "The entry has been deleted.",
        e_detail: "An error occurred while retrieving more information and distributing a catalog item. {{detail}}",
        e_search: "An error occurred while searching for pages. {{detail}}",
      }
    }
  },
  views:{
    adms:{
      list_add_title: "Adding a new item to the catalog",
      list_reload_title: "Reload list",
      card_tab_card: "Card",
      card_tab_collaboration: "Collaboration",
      card_tab_content: "Content",
      collaboration: {
        lifecycle_header: "Lifecycle",
        lifecycle_none: "No lifecycle associated with catalog item",
        event_header: "Events",
        event_none: "No events associated with catalog item",
        wiki_header: "Wiki",
      }
    }
  }
}
